/* Scoped styles - CSS modules will scope these to the component */
.header {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #000;
  gap: 0.75rem;
}

.logo:hover {
  opacity: 0.8;
}

.logoImage {
  width: 74px;
  height: 47px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
}

/* Fallback for when logo path needs to be relative */
@media (max-width: 768px) {
  .logoImage {
    width: 61px;
    height: 39px;
    background-size: 61px 39px;
  }
  
  .logoMain {
    font-size: 1.5rem;
  }
  
  .logoSub {
    font-size: 0.75rem;
  }
  
  .logoPhone {
    font-size: 1.25rem;
  }
}

.logoText {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.logoMain {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  text-transform: uppercase;
}

.logoSub {
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  margin-top: -2px;
}

.logoPhone {
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 2px;
}

.actions {
  display: flex;
  gap: 1rem;
  align-items: center;
  margin: 0;
  padding: 0;
}

.userInfo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  text-decoration: none;
  color: #000;
  cursor: pointer;
}

.userInfo:hover {
  opacity: 0.8;
}

.userName {
  font-size: 13px;
  font-weight: 500;
  color: #000;
}

.userAvatar {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: var(--color-yellow, #ffd700);
  color: white;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
}

.logoutButton {
  padding: 0.5rem 1rem;
  background: transparent;
  color: #000;
  border: 1px solid #000;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  font-family: inherit;
  line-height: 1.4;
  margin: 0;
  box-sizing: border-box;
}

.logoutButton:hover {
  background: #f5f5f5;
}

.loginButton {
  padding: 0.5rem 1rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  display: inline-block;
  font-size: 0.9rem;
  font-family: inherit;
  line-height: 1.4;
  margin: 0;
  box-sizing: border-box;
}

.loginButton:hover {
  background: #333;
}

